import React from 'react';
import {Create} from 'react-admin';
import {BankBinForm} from './BankBinForm';

export const BankBinCreate = (props: unknown): React.ReactElement => <Create {...props}>
    <BankBinForm {...props}/>
</Create>;

